//import React from 'react';
import { connect } from 'react-redux';
import { getDateTime } from '../helper';
import { onBackClick, onNextClick, SAVE_RESUME, saveResume, nuteralizeNextClick, nuteralizeBackClick, PREVIEW_RESUME, deleteSection, onSkipClick, setVersion, setSectionCompleteness, resumeReview } from '../services/actions/actions';
import ResumeReview from '../components/review/ResumeReview';
import { mapDispatchToProps, mapStateToProps } from './EditorContainer';

const ResumeReviewContainer = connect(mapStateToProps, mapDispatchToProps)(ResumeReview);
export default ResumeReviewContainer;
